import React, { version } from 'react'
import {Dropdown, OverlayTrigger, Tooltip} from "react-bootstrap";
import {DropdownTopbarItemToggler} from '../../../../_partials/dropdowns';
import clsx from "clsx";
import {authProvider} from '../../../../../app/provider/authProvider';
import { getUser, getUserReal} from "../../../../../index";
import { toAbsoluteUrl } from "../../../../_helpers";
import { returnUser } from "../../../../../app/helpers/user"
import SVG from "react-inlinesvg";

export class UserMenu extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      user: {},
      userReal: {},
      userFetched: {
        factory: {
          name: ''
        },
        systemRole: {
          name: ''
        }
      },
    }    
      this.user = authProvider.getAccount();
    }

    componentDidMount() {
        this.setState({
            userFetched: getUser()
        })
        this.setState({
          userReal: getUserReal()
        })
        //console.log('UserMenu')
    }


  handleLogout(e) {
    e.preventDefault();
    localStorage.clear();
    authProvider.logout();
  }

    render() {
    return (
      <>
        <Dropdown drop="down" alignRight  onClick={(e) => e.stopPropagation()}>
          <Dropdown.Toggle
            as={DropdownTopbarItemToggler}
          >
            <div className={"btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2"}>
                <span className="text-dark-50 font-weight-bolder font-size-base mr-3">
                {this.state.userFetched ? this.state.userFetched.name : this.user.name }
                </span>
                <span className="svg-icon menu-icon">
                    <SVG className="UserTop" src={toAbsoluteUrl("/media/svg/icons/General/User.svg")} />
                </span>
            </div>
          </Dropdown.Toggle>

          <Dropdown.Menu
            className="p-0 m-0 dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-lg">
            <div className='p-5'>
              <div className="d-flex align-items-stretch justify-content-between">
                <div className="font-weight-bold cursor-pointer">Fábrica original: {this.state.userFetched?.factory.name}</div>
                <div className="text-muted">{this.state.userFetched?.systemRole.name}</div>
              </div>
              <div className=" py-5 ">
                <div className="font-weight-bold ">SAP: {this.state.userFetched?.sap}</div>
              </div>
              <div className=" py-5 ">
                            {this.state.userReal?.id !== this.state.userFetched?.id && this.state.userReal !== null ?
                    <div className="font-weight-bold ">Usuário original: {this.user.name} </div>:null}
                </div>
              <div className='text-right'>
                            {this.state.userReal?.id !== this.state.userFetched?.id && this.state.userReal !== null ?
                    <button className='btn btn-light-danger font-weight-bold' onClick={() => returnUser()}>voltar usuário
                    </button>:null}
                </div>
              <div className='text-right'>
                <button className='btn btn-light-danger font-weight-bold' onClick={(e) => this.handleLogout(e)}>Logout
                </button>
              </div>
            </div>
          </Dropdown.Menu>
        </Dropdown>
      </>
    )
  }
}
